var scope_0 = require('/vercel/path0/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7c089a7794b9f82999d638100f06e783.js').default;
var scope_1 = require('/vercel/path0/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/96860eba2d175e38643090fa02b5623d.js').default;
var scope_2 = require('/vercel/path0/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a253e54263e4ea117a963bd6195360c0.js').default;
var scope_3 = require('/vercel/path0/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_4 = require('/vercel/path0/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fa499ebb31c2bdde5c53918454de1285.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    